'use client'

// src/util/groupEventsByDay.ts
import { formatDate } from "@wbk/utils";
var isContentfulEvent = (event) => "__typename" in event;
var isEventListing = (event) => !("__typename" in event);
function extractDate(event) {
  var _a;
  if (isContentfulEvent(event)) {
    if (!((_a = event.schedule) == null ? void 0 : _a.openDateTime)) return null;
    const d = new Date(event.schedule.openDateTime);
    return isNaN(d.getTime()) ? null : d;
  }
  if (isEventListing(event)) {
    const d = new Date(event.start_date_time * 1e3);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}
var groupEventsByDay = (events, locale) => {
  const grouped = {};
  events.forEach((event) => {
    const date = extractDate(event);
    if (!date) return;
    const dayKey = date.toISOString().split("T")[0];
    if (!grouped[dayKey]) grouped[dayKey] = [];
    grouped[dayKey].push(event);
  });
  return Object.entries(grouped).map(([dayKey, items]) => {
    const firstDate = extractDate(items[0]);
    return {
      dayKey,
      displayDate: formatDate(firstDate, locale, {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric"
      }),
      events: items
    };
  }).sort((a, b) => new Date(a.dayKey).getTime() - new Date(b.dayKey).getTime());
};

export {
  groupEventsByDay
};
//# sourceMappingURL=chunk-HNKZBJGK.mjs.map